import React, { useState } from "react";
import {
  Tooltip,
  ClickAwayListener,
  Paper,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import GetAppIcon from "@mui/icons-material/GetApp";
import AssessmentIcon from "@mui/icons-material/Assessment";

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.common.black,
  maxWidth: 200,
  boxShadow: theme.shadows[8],
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "0.875rem",
  color: theme.palette.common.black,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "& .MuiListItemText-primary": {
    color: theme.palette.common.black,
  },
  "& .MuiListItemText-root": {
    color: theme.palette.common.black,
  },
}));

interface InteractiveTooltipProps {
  children: React.ReactElement;
  onExcelDownload: () => void;
  onProgressReport: () => void;
  placement?: "top" | "bottom" | "left" | "right";
}

const InteractiveTooltip: React.FC<InteractiveTooltipProps> = ({
  children,
  onExcelDownload,
  onProgressReport,
  placement = "top",
}) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleExcelClick = () => {
    onExcelDownload();
    setOpen(false);
  };

  const handleProgressClick = () => {
    onProgressReport();
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          placement={placement}
          title={
            <StyledPaper elevation={3}>              <MenuList dense>
                <StyledMenuItem onClick={handleExcelClick}>
                  <ListItemIcon>
                    <GetAppIcon fontSize="small" color="primary" />
                  </ListItemIcon>
                  <ListItemText 
                    primary="Desglose de pagos" 
                    sx={{ color: 'black', '& .MuiTypography-root': { color: 'black' } }}
                  />
                </StyledMenuItem>
                <StyledMenuItem onClick={handleProgressClick}>
                  <ListItemIcon>
                    <AssessmentIcon fontSize="small" color="secondary" />
                  </ListItemIcon>
                  <ListItemText 
                    primary="Reporte de Avance" 
                    sx={{ color: 'black', '& .MuiTypography-root': { color: 'black' } }}
                  />
                </StyledMenuItem>
              </MenuList>
            </StyledPaper>
          }
        >
          <div onClick={handleTooltipOpen}>
            {children}
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default InteractiveTooltip;
